import styled from 'styled-components';
export const ButtonContainer = styled.div.withConfig({ displayName: "ButtonContainer", componentId: "sc-cvd9ig" }) `
  margin-left: auto; 
  margin-right: 10px;
  min-width: 200px;
  display: flex;
  flex-direction: row-reverse;
`;
